import React, { useState, useEffect } from "react";
import "./Login.css";
import "../../styles/global.css";
import ButtonPrimary from '../../components/buttons/ButtonPrimary';
import RegistrationForm from './RegistrationForm';
import LoginForm from './LoginForm';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaDiscord, FaTwitter, FaInstagram } from 'react-icons/fa';
import { useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';

function Login() {
    const location = useLocation();

    // Get the register query parameter
    const queryParams = new URLSearchParams(location.search);
    const showRegisterInitial = queryParams.get('register') === 'true';

    const [showRegister, setShowRegister] = useState(showRegisterInitial);

    const handleToggleLogin = () => {
        setShowRegister(false);
    };

    const handleToggleRegister = () => {
        setShowRegister(true);
    };

    return (
        <div className="landing-page">
            <ToastContainer />

            <div className="back-home-link">
                <Link to="/">← Back to home</Link>
            </div>

            {/* First Part */}
            <div className="top-section text-center">
                {showRegister ? (
                    <RegistrationForm onToggleLogin={handleToggleLogin} />
                ) : (
                    <LoginForm onToggleRegister={handleToggleRegister} />
                )}
            </div>
        </div>
    );
}

export default Login;
